import React from "react";
import { Tag, Popconfirm, Space, message, Row, Col } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import { DeleteOutlined, EditFilled, EditOutlined } from "@ant-design/icons";
import ExportExcelWidget from "components/ExportExcelWidget/ExportExcelWidget";
export function showColumnAction(info, setVisible, setUserData, deleteData) {
  return (
    <Row gutter={16}>
      <Col>
        <a
          style={{ color: "var(--blueColor)" }}
          onClick={async (e) => {
            e.stopPropagation();
            setUserData(info);
            setVisible(info);
          }}
        >
          <EditFilled /> Edit
        </a>
      </Col>
      <Col>
        <a
          style={{ color: "red" }}
          onClick={async (e) => {
            e.stopPropagation();
            var res = await showConfirmDlgWidget({
              title: "Delete Confirmation",
              content: "Are you sure you want to delete this user?",
            });
            if (res == false) return;
            deleteData(info.id);
          }}
        >
          <DeleteOutlined /> Delete
        </a>
      </Col>
    </Row>
  );
}
